import { RemixiconComponentType } from '@remixicon/react';

export const ConfidenceLogo: RemixiconComponentType = ({
  size = 24,
  color = 'currentColor',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.97 0A2.97 2.97 0 0 0 0 2.97v18.06A2.97 2.97 0 0 0 2.97 24h18.06A2.97 2.97 0 0 0 24 21.03V2.97A2.97 2.97 0 0 0 21.03 0H2.97Zm8.694 11.14a.495.495 0 0 1-.494.494H6.345a.495.495 0 0 1-.495-.494V6.315c0-.273.222-.495.495-.495h4.825c.273 0 .494.222.494.495v4.825Zm2.598.494a3.959 3.959 0 0 0 3.96-3.958V6.315a.495.495 0 0 0-.496-.495h-4.824a.495.495 0 0 0-.495.495v4.825c0 .273.221.494.495.494h1.36Zm1.052 6.557a2.907 2.907 0 1 0 0-5.814 2.907 2.907 0 0 0 0 5.814Zm-6.557 0a2.907 2.907 0 1 0-2.907-2.907v2.412c0 .274.222.495.495.495h2.412Z"
    />
  </svg>
);
